function escapeHtml(value) {
  return String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function formatQty(value) {
  const num = Number(value) || 0;
  return num.toFixed(2);
}

function formatAmount(value) {
  const num = Number(value) || 0;
  return num.toFixed(2);
}

const RECEIPT_CONFIG = {
  title: "ARF Seafoods",
  headerLines: [
    "Verkodu",
    "Rameshwaram",
    "9894286738",
  ],
  footerBrand: "ARF Seafoods",
};

function resolvePublicAsset(path) {
  const cleanPath = String(path || "").replace(/^\/*/, "");
  const base = process.env.PUBLIC_URL || "";
  const basePath = String(base).replace(/\/+$/, "");
  const relative = `${basePath}/${cleanPath}`.replace(/\/{2,}/g, "/");
  try {
    return new URL(relative, window.location.href).toString();
  } catch (e) {
    return relative;
  }
}

export async function getLogoDataUrl() {
  if (getLogoDataUrl.cache) return getLogoDataUrl.cache;
  const url = resolvePublicAsset("Logo.png");
  try {
    const res = await fetch(url);
    const blob = await res.blob();
    const dataUrl = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
    getLogoDataUrl.cache = dataUrl;
    return dataUrl;
  } catch (e) {
    console.error("Logo load failed, using url", e);
    getLogoDataUrl.cache = url;
    return url;
  }
}

export async function getQrDataUrl() {
  if (getQrDataUrl.cache) return getQrDataUrl.cache;
  const url = resolvePublicAsset("alifqr.PNG");
  try {
    const res = await fetch(url);
    const blob = await res.blob();
    const dataUrl = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
    getQrDataUrl.cache = dataUrl;
    return dataUrl;
  } catch (e) {
    console.error("QR load failed, using url", e);
    getQrDataUrl.cache = url;
    return url;
  }
}

function buildReceiptHtml({
  logoUrl,
  billNo,
  billDate,
  billTime,
  customerLines,
  items,
  totalQty,
  totalAmount,
}) {
  const customerBlock = customerLines.length
    ? customerLines.map((line) => `<div>${escapeHtml(line)}</div>`).join("")
    : "<div>Walk-in</div>";

  const rows = items
    .map(
      (item, index) => `
        <tr>
          <td class="center">${index + 1}</td>
          <td>${escapeHtml(item.material)}</td>
          <td class="right">${formatQty(item.qty)}</td>
          <td class="right">${formatAmount(item.rate)}</td>
          <td class="right">${formatAmount(item.amount)}</td>
        </tr>
      `
    )
    .join("");

  return `<!doctype html>
  <html>
    <head>
      <meta charset="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1, viewport-fit=cover" />
      <title>Bill ${escapeHtml(billNo)}</title>
      <style>
        @page { size: 80mm auto; margin: 4mm; }
        * { box-sizing: border-box; }
        html, body {
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
        body {
          margin: 0;
          padding: 0;
          font-family: Arial, Helvetica, sans-serif;
          color: #000;
          background: #fff;
          font-size: 12px;
          font-weight: 600;
        }
        .receipt { width: 72mm; margin: 0 auto; border: 1px solid #000; padding: 2mm; }
        .center { text-align: center; }
        .right { text-align: right; }
        .bold { font-weight: 700; }
        .divider { border-top: 1px solid #000; margin: 6px 0; }
        .header { display: flex; gap: 10px; align-items: center; }
        .header-left { width: 26mm; flex: 0 0 26mm; }
        .header-right { flex: 1; text-align: center; line-height: 1.2; font-weight: 700; }
        .logo { width: 100%; height: auto; display: block; }
        .section-title {
          text-align: center;
          font-weight: 700;
          font-size: 14px;
          padding: 4px 0;
          border-top: 1px solid #000;
          border-bottom: 1px solid #000;
          background: #f1f5f9;
        }
        .customer-block { padding: 6px 0; font-size: 14px; line-height: 1.3; }
        .meta-row { display: flex; justify-content: space-between; align-items: baseline; gap: 10px; }
        .label { font-weight: 700; }
        table { width: 100%; border-collapse: collapse; margin-top: 0; }
        th, td { padding: 3px 4px; border: 1px solid #000; vertical-align: top; }
        th { font-weight: 700; background: #f1f5f9; }
        .totals-row td { font-weight: 700; }
        .total-amount {
          display: flex;
          justify-content: space-between;
          font-weight: 900;
          font-size: 16px;
          margin-top: 6px;
          padding-top: 6px;
          border-top: 1px solid #000;
        }
        .footer { margin-top: 8px; text-align: center; font-weight: 700; }
        .footer-brand { margin-top: 4px; font-weight: 700; }
        @media screen {
          body {
            min-height: 100vh;
            min-height: 100dvh;
            background: #f8fafc;
          }
          .receipt {
            width: 100%;
            max-width: 560px;
            min-height: calc(100vh - 24px);
            min-height: calc(100dvh - 24px);
            margin: 12px auto;
            padding: 14px;
            background: #fff;
          }
        }
        @media screen and (max-width: 600px) {
          body { font-size: 14px; background: #fff; }
          .receipt {
            max-width: none;
            min-height: 100vh;
            min-height: 100dvh;
            margin: 0;
            padding: 12px;
            border: 0;
          }
          .header { gap: 12px; }
          .header-left { width: 30%; flex-basis: 30%; }
          .header-right { font-size: 12px; }
          .customer-block { font-size: 15px; }
          table { table-layout: fixed; font-size: 12px; }
          th, td { padding: 4px 3px; overflow-wrap: anywhere; }
        }
      </style>
    </head>
    <body>
      <div class="receipt">
        <div class="header">
          <div class="header-left">
            ${
              logoUrl
                ? `<img class="logo" src="${escapeHtml(logoUrl)}" alt="Logo" />`
                : `<div class="bold">${escapeHtml(RECEIPT_CONFIG.title)}</div>`
            }
          </div>
          <div class="header-right">
            ${RECEIPT_CONFIG.headerLines.map((line) => `<div>${escapeHtml(line)}</div>`).join("")}
          </div>
        </div>
        <div class="divider"></div>
        <div class="section-title">Customer Details:</div>
        <div class="customer-block">${customerBlock}</div>
        <div class="divider"></div>
        <div class="meta-row">
          <div><span class="label">Bill No:</span> ${escapeHtml(billNo)}</div>
          <div></div>
        </div>
        <div class="meta-row">
          <div><span class="label">Date:</span> ${escapeHtml(billDate)}</div>
          <div>${billTime ? escapeHtml(billTime) : ""}</div>
        </div>
        <div class="divider"></div>
        <table>
          <thead>
            <tr>
              <th style="width: 8%;" class="center">S.<br/>No</th>
              <th style="width: 46%;">Particulars</th>
              <th style="width: 14%;" class="right">Qty</th>
              <th style="width: 16%;" class="right">Rate</th>
              <th style="width: 16%;" class="right">Gross</th>
            </tr>
          </thead>
          <tbody>
            ${rows}
            <tr class="totals-row">
              <td></td>
              <td>Total</td>
              <td class="right">${formatQty(totalQty)}</td>
              <td></td>
              <td class="right">${formatAmount(totalAmount)}</td>
            </tr>
          </tbody>
        </table>
        <div class="total-amount">
          <span>Total Amount</span>
          <span>${formatAmount(totalAmount)}</span>
        </div>
        <div class="footer">
          <div class="footer-brand">${escapeHtml(RECEIPT_CONFIG.footerBrand)}</div>
        </div>
      </div>
    </body>
  </html>`;
}

export async function buildReceiptHtmlDocument(receiptData) {
  const resolvedLogoUrl = await (receiptData?.logoUrl
    ? Promise.resolve(receiptData.logoUrl)
    : getLogoDataUrl().catch(() => {
        try {
          return resolvePublicAsset("Logo.png");
        } catch (e) {
          return "";
        }
      }));

  return buildReceiptHtml({
    ...receiptData,
    logoUrl: resolvedLogoUrl,
  });
}

export async function printReceiptWindow(receiptData) {
  const printWindow = window.open("", "PRINT", "height=600,width=400");
  if (!printWindow) {
    alert("Please allow popups to print the receipt.");
    return;
  }

  const html = await buildReceiptHtmlDocument(receiptData);

  const triggerPrint = () => {
    try {
      printWindow.focus();
    } catch (e) {
      // ignore
    }
    setTimeout(() => {
      try {
        printWindow.print();
      } finally {
        try {
          printWindow.close();
        } catch (e) {
          // ignore
        }
      }
    }, 50);
  };

  printWindow.document.write(html);
  printWindow.document.close();

  const waitForImages = () => {
    const images = Array.from(printWindow.document.images || []);
    if (images.length === 0) return Promise.resolve();
    return Promise.all(
      images.map(
        (img) =>
          new Promise((resolve) => {
            if (img.complete) {
              resolve();
              return;
            }
            img.addEventListener("load", resolve, { once: true });
            img.addEventListener("error", resolve, { once: true });
          })
      )
    );
  };

  Promise.race([waitForImages(), new Promise((resolve) => setTimeout(resolve, 2500))]).then(() =>
    triggerPrint()
  );
}
